import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  SaveIcon,
  CancelIcon,
} from "../../../../shared/utils/muiImports";
import { StaffFormProps } from "../Staff.type";
import { GenderTypeEnum } from "../../../../shared/utils/enum";
import { formatDateForInput } from "../../../../shared/utils/formatDate";

const StaffForm: React.FC<StaffFormProps> = ({
  staff,
  errors,
  onChange,
  onSave,
  onCancel,
}) => {
  type GenderKey = keyof typeof GenderTypeEnum;

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <TextField
            label="User Name"
            name="userName"
            fullWidth
            margin="none"
            size="small"
            required
            onChange={onChange}
            value={staff?.userName || ""}
            error={!!errors.userName}
            helperText={errors.userName}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="First Name"
            name="firstName"
            fullWidth
            margin="none"
            size="small"
            required
            onChange={onChange}
            value={staff?.firstName || ""}
            error={!!errors.firstName}
            helperText={errors.firstName}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Last Name"
            name="lastName"
            fullWidth
            margin="none"
            size="small"
            value={staff?.lastName || ""}
            error={!!errors.lastName}
            helperText={errors.lastName}
            required
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Phone Number"
            name="phoneNumber"
            fullWidth
            margin="none"
            size="small"
            inputProps={{ maxLength: 10 }}
            required
            value={staff?.phoneNumber || ""}
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber}
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Email"
            name="email"
            fullWidth
            margin="none"
            size="small"
            value={staff?.email || ""}
            error={!!errors.email}
            helperText={errors.email}
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Date of Birth"
            name="dateOfBirth"
            fullWidth
            margin="none"
            size="small"
            type="date"
            required
            value={formatDateForInput(staff?.dateOfBirth)}
            error={!!errors.dateOfBirth} // Custom error handling
            helperText={errors.dateOfBirth} // Custom error message
            onChange={onChange} // Update state on date change
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Gender"
            name="gender"
            fullWidth
            margin="none"
            size="small"
            select
            required
            value={staff?.gender || ""}
            error={!!errors.gender}
            helperText={errors.gender}
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
          >
            {Object.keys(GenderTypeEnum).map((key) => (
              <MenuItem key={key} value={GenderTypeEnum[key as GenderKey]}>
                {GenderTypeEnum[key as GenderKey]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Address"
            name="address"
            fullWidth
            margin="none"
            size="small"
            required
            value={staff?.address || ""}
            error={!!errors.address}
            helperText={errors.address}
            onChange={onChange}
            multiline
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12}>
            <Button
              variant="outlined"
              color="primary"
              sx={{ mr: 1, width: 100 }}
              startIcon={<SaveIcon />}
              onClick={onSave}
            >
              Save
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              sx={{ width: 100 }}
              startIcon={<CancelIcon />}
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StaffForm;
